import { $t } from '@/i18n';
import { defineComponent, onMounted, onUnmounted, ref, computed } from '@vue/composition-api';
import { jsonToYaml } from '@/utils/merge/jsonToYaml';
import { useRouter } from '@/router/useRouter';
import { aiMergeEditorRoutePath } from '@/router/route-const';
import { BASE_PATH } from '@/config/constant';
export default defineComponent({
    name: 'AIConflictView',
    props: {
        conflictItem: {
            type: Object,
            default: () => ({}),
        },
        currentBranchLabel: {
            type: String,
            default: '',
        },
        mergeBranchLabel: {
            type: String,
            default: '',
        },
        resolved: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change', 'mergeSuccess'],
    setup(props, { emit }) {
        const { route } = useRouter();
        const iframeRef = ref(null);
        // 获取当前分支的主分支数据
        const oursMainBranch = computed(() => props.conflictItem?.oursData?.mainBranch || '');
        const theirsMainBranch = computed(() => props.conflictItem?.theirsData?.mainBranch || '');
        // 构建 iframe URL
        const iframeSrc = computed(() => {
            const projectId = route.value?.query?.projectid || '';
            const branch = route.value?.query?.branch || '';
            const params = new URLSearchParams({
                projectid: projectId,
                branch,
                ours: oursMainBranch.value,
                theirs: theirsMainBranch.value,
                oursName: props.currentBranchLabel,
                theirsName: props.mergeBranchLabel,
            });
            // 构建完整的 URL 路径
            const basePath = BASE_PATH || '';
            return `${basePath.replace(/\/$/, '')}${aiMergeEditorRoutePath}?${params.toString()}`;
        });
        // 处理来自 iframe 的消息
        const handleMessage = (event) => {
            const { data } = event;
            if (data?.source !== 'ai-editor-merge')
                return;
            switch (data.type) {
                case 'ready':
                    console.log('[AIConflictView] Editor iframe ready:', data.payload);
                    break;
                case 'mergeSuccess':
                    console.log('[AIConflictView] Merge success:', data.payload);
                    if (data.payload?.projectInfo) {
                        const change = jsonToYaml(data.payload.projectInfo);
                        emit('change', { data: change, resolved: true });
                    }
                    break;
                case 'error':
                    console.error('[AIConflictView] Editor error:', data.payload?.message);
                    break;
                default:
                    console.log('[AIConflictView] Unknown message type:', data.type);
            }
        };
        onMounted(() => {
            window.addEventListener('message', handleMessage);
        });
        onUnmounted(() => {
            window.removeEventListener('message', handleMessage);
        });
        return {
            iframeRef,
            iframeSrc,
        };
    },
    render() {
        // 如果合并成功，显示成功提示
        if (this.resolved) {
            return (<div style={{
                    width: '100%',
                    height: 'calc(100vh - 230px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                }}>
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" style={{ marginBottom: '8px' }}>
            <circle cx="32" cy="32" r="32" fill="#52c41a"/>
            <path d="M20 32l8 8 16-16" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div style={{
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#333',
                }}>
            {$t('k_d84bdaaa')}
          </div>
          <div style={{
                    fontSize: '14px',
                    color: '#666',
                }}>
            {$t('k_167b57af')}
          </div>
        </div>);
        }
        return (<div style={{ width: '100%', height: 'calc(100vh - 230px)' }}>
        <iframe ref="iframeRef" src={this.iframeSrc} style={{
                width: '100%',
                height: '100%',
                border: 'none',
            }} sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-clipboard-read allow-clipboard-write"/>
      </div>);
    },
});
